import { Slider } from '@sharcoux/slider'

export default Slider;
